import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Вместительный рюкзак спасёт, когда вещей много, а руки должны быть свободны. Он незаменим в поездках и пеших походах, на долгой прогулке и в школе. Широкие ремни распределяют нагрузку и регулируются по длине. Принт наносится на всю поверхность и рюкзак выглядит заметно и стильно.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
